import React from 'react';

/**
 * Schema.org LocalBusiness - SEO Local optimisé
 *
 * Ce composant ajoute des données structurées invisibles pour l'utilisateur
 * mais essentielles pour le SEO local et Google My Business.
 *
 * Avantages :
 * ✅ Améliore le ranking sur les recherches locales
 * ✅ Apparaît dans Google Maps
 * ✅ Rich snippets dans les résultats de recherche
 * ✅ Cible plusieurs villes (Roncq, Phalempin, métropole lilloise)
 */
const SchemaOrgLocalBusiness = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Olney Tech Solutions",
    "image": "https://olney.dev/logo.png",
    "@id": "https://olney.dev",
    "url": "https://olney.dev",
    "telephone": "+33689177385",
    "email": "contact@olney.dev",
    "priceRange": "€€",
    "founder": {
      "@type": "Person",
      "name": "Anthony Vanheule"
    },
    "foundingDate": "2022",
    "numberOfEmployees": {
      "@type": "QuantitativeValue",
      "value": "1-5"
    },
    "sameAs": [
      "https://www.linkedin.com/company/olney-tech",
      "https://github.com/olney-tech"
    ],

    // Adresse principale - RONCQ
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "", // TODO: Ajouter votre adresse de rue exacte à Roncq
      "addressLocality": "Roncq",
      "postalCode": "59223",
      "addressRegion": "Hauts-de-France",
      "addressCountry": "FR"
    },

    // Coordonnées GPS de Roncq
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "50.7469",
      "longitude": "3.1228"
    },

    // Zone de service - Inclut Phalempin et métropole lilloise
    "areaServed": [
      {
        "@type": "City",
        "name": "Roncq",
        "description": "Ville principale - Siège social"
      },
      {
        "@type": "City",
        "name": "Phalempin",
        "description": "Zone d'intervention prioritaire"
      },
      {
        "@type": "City",
        "name": "Seclin"
      },
      {
        "@type": "City",
        "name": "Lesquin"
      },
      {
        "@type": "City",
        "name": "Templeuve"
      },
      {
        "@type": "City",
        "name": "Cysoing"
      },
      {
        "@type": "City",
        "name": "Orchies"
      },
      {
        "@type": "City",
        "name": "Lille"
      },
      {
        "@type": "City",
        "name": "Tourcoing"
      },
      {
        "@type": "City",
        "name": "Roubaix"
      },
      {
        "@type": "City",
        "name": "Villeneuve-d'Ascq"
      },
      // Zone géographique large (25km autour de Roncq)
      {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": "50.7469",
          "longitude": "3.1228"
        },
        "geoRadius": "25000" // 25km - couvre toute la métropole lilloise
      }
    ],

    // Services proposés
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services Informatiques",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Développement Web",
            "description": "Sites vitrine, e-commerce, applications web React/Vue.js sur mesure"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Infrastructure Cloud",
            "description": "Migration et gestion cloud AWS, Azure, Google Cloud"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Intelligence Artificielle",
            "description": "Intégration IA, chatbots, automatisation"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Maintenance & Support",
            "description": "Support technique 24/7, maintenance préventive"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Cybersécurité",
            "description": "Audits de sécurité, tests d'intrusion, protection des données"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Applications Mobiles",
            "description": "Développement d'applications iOS et Android"
          }
        }
      ]
    },

    // Horaires d'ouverture
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday"
        ],
        "opens": "09:00",
        "closes": "18:00"
      }
    ],

    // Informations complémentaires
    "description": "Olney Tech Solutions propose des solutions informatiques complètes pour les PME de la métropole lilloise : développement web, infrastructure cloud, cybersécurité, assistance technique. Basés à Roncq, interventions rapides sur Phalempin, Seclin, Lesquin et toute la région Nord.",

    "slogan": "Solutions Informatiques Sur Mesure pour Votre Entreprise",

    // Méthodes de paiement acceptées
    "paymentAccepted": "Cash, Credit Card, Bank Transfer",

    // Langues parlées
    "availableLanguage": ["French", "English"]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData, null, 2) }}
    />
  );
};

export default SchemaOrgLocalBusiness;
